// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".NotFound_wrapper__3SY9G span {\n  font-weight: 600;\n  font-size: 20px;\n  line-height: 28px;\n  color: #262626; }\n\n.NotFound_wrapper__3SY9G .ant-empty-image {\n  height: auto; }\n  .NotFound_wrapper__3SY9G .ant-empty-image > img {\n    width: 160px;\n    height: auto; }\n", ""]);
// Exports
exports.locals = {
	"wrapper": "NotFound_wrapper__3SY9G"
};
module.exports = exports;
